import styled from "styled-components";

const Div = styled.div`
  position: relative;

  p {
    position: absolute;
    color: white;
    top: 0;
    padding: 1rem 0.75rem 0.5rem 1rem;
    right: 0;
    font-family: Avenir next;
    text-transform: capitalize;
    font-size: 0.5rem;
    z-index: 1;
  }
`;

const P = styled.p<{layout: string}>`
  position: absolute;
  color: white;
  top: 10%;
  padding: 1rem 0.75rem 0.5rem 1rem;
  right: ${({ layout }) =>
  layout === "right" ? "0" : ""};
  font-family: Avenir next;
  text-transform: capitalize;
  font-size: 0.5rem;
  z-index: 1;
  opacity: 0.5;

  @media ${({ theme }) => theme.breakpoints.md} {
    right: 10%;
    font-size: 0.4rem;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    top: 0;
    right: 10%;
    font-size: 0.3rem;
  }
`;

const Container = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
  padding: 70px 0 70px 0;
  width: calc(100% + 140px);
  margin-left: -70px;
  min-height: 400px;
  margin-bottom: ${({ theme }) => theme.margins.bottom};

  overflow: hidden;

  .gatsby-image {
    @media ${({ theme }) => theme.breakpoints.md} {
      display: none;
    }
  }

  .gatsby-image-mobile {
    display: none;
    @media ${({ theme }) => theme.breakpoints.md} {
      display: initial;
    }
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    width: 100vw;
    margin-left: -70px;
    padding: 70px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-left: -16px;
    padding: 0 0 23px 0;
    margin-bottom: ${({ theme }) => theme.margins.bottomMobile};
  }
`;

const BackgroundLeft = styled.div<{
  backgroundColor: string;
  layout: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-clip-path: ${({ layout }) =>
    layout === "tilted"
      ? "polygon(10% 0, 100% 1%, 100% 100%, 25% 100%, 40% 100%)"
      : "polygon(10% 0, 100% 1%, 100% 100%, 25% 100%, 10% 100%)"};

  clip-path: ${({ layout }) =>
    layout === "tilted"
      ? "polygon(10% 0, 100% 1%, 100% 100%, 25% 100%, 40% 100%)"
      : "polygon(10% 0, 100% 1%, 100% 100%, 25% 100%, 10% 100%)"};

  z-index: -1;

  @media ${({ theme }) => theme.breakpoints.md} {
    -webkit-clip-path: ${({ layout }) =>
      layout === "tilted"
        ? "polygon(0 15%, 100% 5%, 100% 100%, 0% 100%);"
        : "polygon(0 15%, 100% 15%, 100% 100%, 0% 100%)"};

    clip-path: ${({ layout }) =>
      layout === "tilted"
        ? "polygon(0 15%, 100% 5%, 100% 100%, 0% 100%);"
        : "polygon(0 15%, 100% 15%, 100% 100%, 0% 100%)"};
  }
`;

const BackgroundRight = styled.div<{
  backgroundColor: string;
  backgroundLayout: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-clip-path: ${({ backgroundLayout }) =>
    backgroundLayout === "tilted"
      ? "polygon(0 0, 90% 0, 60% 100%, 25% 100%, 0 100%)"
      : "polygon(0 0, 90% 0, 90% 100%, 25% 100%, 0 100%)"};

  clip-path: ${({ backgroundLayout }) =>
    backgroundLayout === "tilted"
      ? "polygon(0 0, 90% 0, 60% 100%, 25% 100%, 0 100%)"
      : "polygon(0 0, 90% 0, 90% 100%, 25% 100%, 0 100%)"};

  z-index: -1;

  @media ${({ theme }) => theme.breakpoints.md} {
    -webkit-clip-path: ${({ backgroundLayout }) =>
      backgroundLayout === "tilted"
        ? "polygon(0 5%, 100% 15%, 100% 100%, 0% 100%);"
        : "polygon(0 15%, 100% 15%, 100% 100%, 0% 100%)"};

    clip-path: ${({ backgroundLayout }) =>
      backgroundLayout === "tilted"
        ? "polygon(0 5%, 100% 15%, 100% 100%, 0% 100%);"
        : "polygon(0 15%, 100% 15%, 100% 100%, 0% 100%)"};
  }
`;

const AccentTitle = styled.span`
  color: #a78f67;
`;

const TextWrapper = styled.div<{ backgroundColor: string }>`
  margin-top: ${({ backgroundColor }) =>
    backgroundColor === "white" ? "0" : "20px"};
  display: flex;
  flex-direction: column;
  padding: 0 50px 0 70px;
  justify-content: ${({ backgroundColor }) =>
    backgroundColor === "white" ? "center" : "flex-start"};

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-top: 50px;
    padding: 0;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 0 16px;
    margin-top: 25px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 650px;
  object-fit: cover;
  object-position: center;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

const GatsbyImage = styled.div`
  height: 100%;
  max-width: 100%;
  max-height: 650px;
  object-fit: cover;
  object-position: center; */

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

const MobileImage = styled.img`
  display: none;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: initial;
    width: calc(100% - 40px);
    margin-left: 20px;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
const MobileVideo = styled.video`
  display: none;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: initial;
    width: calc(100% - 40px);
    margin-left: 20px;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

const Line = styled.div<{ backgroundColor: string }>`
  border: 2px solid
    ${(props) => (props.backgroundColor === "white" ? "#000" : "#fff")};
  width: 200px;
  height: 0px;
  margin: 30px 0;
`;

const S = {
  Container,
  BackgroundLeft,
  BackgroundRight,
  AccentTitle,
  TextWrapper,
  Line,
  Image,
  GatsbyImage,
  MobileImage,
  Video,
  MobileVideo,
  Div,
  P
};

export default S;
